<div class="page-header py-2 mb-4" [ngClass]="{ high_zindex: higherLevel }">
  <!-- back button & page title -->
  <div class="d-flex flex-column gap-2">
    <div
      *ngIf="backButton"
      [translatable]="{
        transKey: 'shared.back',
        modEnum: translationModulesEnum.shared
      }"
    >
      <button class="new-back-btn" (click)="back()">
        <i class="bx bx-left-arrow-alt"></i>
        <span>{{ "shared.back" | translate }}</span>
      </button>
    </div>

    <div class="module-title">
      <span
        class="title"
        *ngIf="isStartServiseTitle"
        [translatable]="{
          transKey: 'shared.startService',
          modEnum: translationModulesEnum.shared
        }"
      >
        {{ "shared.startService" | translate }}
      </span>

      <!-- TODO: translationKey='' -->
      <span
        [translatable]="{
          transKey: translationKey,
          modEnum: selectedTranslationModuleEnum
        }"
        class="mainTitle"
      >
        {{ title }}
      </span>

      <span class="totalItems" *ngIf="showTotalItems">({{ totalItems }})</span>
      <span>
        <ng-content></ng-content>
      </span>
    </div>
  </div>

  <div class="d-flex flex-wrap gap-2 custom-actions">
    <!-- filter select -->
    <ng-content select="[filters-select]"></ng-content>

    <!-- search field -->
    <app-search
      *ngIf="isSearch"
      (search)="changeSearch($event)"
      [searchKey]="searchKey"
      #search
    ></app-search>

    <!-- advanced filter button -->
    <div
      *ngIf="hasAdvancedFilter"
      [translatable]="{
        transKey: 'shared.filter',
        modEnum: translationModulesEnum.shared
      }"
    >
      <button class="advanced-filter-btn" (click)="advancedFilter()">
        <img src="assets/icons/filter-2.svg" alt="filter" />

        {{ "shared.filter" | translate }}
        <span
          class="filterCount-advanced"
          *ngIf="showTotalFilterAdvanced && filterCount > 0"
        >
          {{ filterCount }}
        </span>
      </button>
    </div>

    <!-- add new button -->
    <div
      *ngIf="isAddBtn"
      [translatable]="{
        transKey: titleBtnTranslationKey,
        modEnum: titleBtnTranslationModuleEnum
      }"
    >
      <button
        [disabled]="addBtnDisabled"
        class="btn btn-main add-new-btn"
        (click)="evnet()"
      >
        <i class="bx bx-plus"></i>
        {{ titleBtn }}
      </button>
    </div>
  </div>

  <ng-content select="[buttons]"></ng-content>
</div>
